<template>
  <div class="toggle-container">
    <!-- Off / Active -->
    <calico-toggle v-model="enabledOff" />

    <!-- On / Active -->
    <calico-toggle v-model="enabledOn" />

    <!-- Off / Disabled -->
    <calico-toggle
      v-model="enabledDisabled"
      disabled
    />
  </div>
</template>

<script>
import CalicoToggle from '@/components/calico/toggle/index.vue'

export default {
  name: 'CalicoTogglePage',
  components: {
    CalicoToggle
  },
  data () {
    return {
      enabledOff: false,
      enabledOn: true,
      enabledDisabled: false
    }
  },
  watch: {
    enabledOff (value) {
      console.log('Off toggle:', value)
    },
    enabledOn (value) {
      console.log('On toggle:', value)
    },
    enabledDisabled (value) {
      console.log('Disabled toggle:', value)
    }
  }
}
</script>

<style lang="scss">
.toggle-container {
  justify-content: center;
  align-items: center;
  @include inset-space($space-xxxlarge);
  @include inline-space($space-medium);
}
</style>
